import data from "../../.sourceflow/dynamic_page_modules.json";
import { useState } from "react";

export const useModule = (id) => {
  const [module] = useState(data.find((i) => i.id === id));

  return module;
};

export default useModule;
